// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".field-tooltip .tooltip-content {\n  max-width: 220px;\n  white-space: normal;\n  text-align: right;\n  right: 0 !important;\n  left: auto !important;\n  transform: translateX(0) !important;\n}\n", ""]);
// Exports
module.exports = exports;
